import { render } from "./upAnalysis.vue?vue&type=template&id=4c3378f7&scoped=true&ts=true"
import script from "./upAnalysis.vue?vue&type=script&lang=ts"
export * from "./upAnalysis.vue?vue&type=script&lang=ts"

import "./upAnalysis.vue?vue&type=style&index=0&id=4c3378f7&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3378f7"]])

export default __exports__